import { useState, useEffect, useCallback } from 'react';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import { Stack } from '@mui/material';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

// components
import Scrollbar from '../../components/scrollbar';

// services
import Loading from '../../layouts/loading';
import { AddSection, Section } from './boardview/components';
import { getSectionsByProjectId } from '../../services/sectionService';
import { fetchRunningTask } from '../../services/trackerService';
import { useProject } from './Layout/header/context';
import { isClient, isStakeholder } from '../../utils/share';

// ----------------------------------------------------------------------

function ProjectBoard() {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [sections, setSections] = useState([]);
  const [refetcher, setRefetcher] = useState(false);
  const [runningTask, setRunningTask] = useState(null);

  const { projectDetails, isEditPermission } = useProject();

  const fetchSectionsSilent = useCallback(async () => {
    try {
      const response = await getSectionsByProjectId(id);
      setSections(response?.data?.data?.rows);
    } catch (error) {
      toast.error(error.message);
    }
  }, [id]);

  const fetchSections = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getSectionsByProjectId(id);
      setSections(response?.data?.data?.rows);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  }, [id]);

  const refetchSection = useCallback(
    (showLoader = true) => {
      if (showLoader) {
        setRefetcher((prev) => !prev);
      } else {
        // Silent refetch without page loader
        fetchSectionsSilent();
      }
    },
    [fetchSectionsSilent]
  );

  const fetchRunningTaskData = async () => {
    const runningTaskResponse = await fetchRunningTask();
    setRunningTask(runningTaskResponse?.data?.data);
  };

  useEffect(() => {
    fetchSections();
    fetchRunningTaskData();
  }, [fetchSections, refetcher]);

  const createTaskDisabled = projectDetails?.allowManualTask === false && !isEditPermission;

  // Filter sections for stakeholders - only show "Issues" or "issue" 

  return (
    <>
      <DndProvider backend={HTML5Backend}>
        <Scrollbar containerProps={{ style: { height: 'calc(100% - 100px)' } }} sx={{ height: '100%' }}>
          <Stack direction="row" spacing={2}>
            {sections.map((section) => (
              <Section
                key={section?.id}
                section={section}
                refetchSection={refetchSection}
                setLoading={setLoading}
                runningTask={runningTask}
              />
            ))}
            {!createTaskDisabled && <AddSection refetchSection={refetchSection} />}
          </Stack>
        </Scrollbar>
        <Loading open={isLoading} />
      </DndProvider>
    </>
  );
}
export default ProjectBoard;
